import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import getDate from 'date-fns/getDate'
import isSameDay from 'date-fns/isSameDay'
import isSameMonth from 'date-fns/isSameMonth'

type Props = {
  currentMonth: Date
  date: Date
  isActive: boolean
  selectDate: (date: Date) => void
}

const HolidayCalendarCell: FC<Props> = React.memo((props) => {
  const { currentMonth, date, isActive, selectDate } = props

  const isThisMonth = isSameMonth(date, currentMonth)

  const className = (() => {
    switch (true) {
      // 選択状態
      case isThisMonth && isActive:
        return styles.table__cell_active
      // 今日の日付
      case isThisMonth && isSameDay(date, new Date()):
        return styles.table__cell_today
      default:
        return styles.table__cell
    }
  })()

  return (
    <td className={className} onClick={() => (isThisMonth ? selectDate(date) : null)}>
      <span className={styles.table__cell__date}>{isThisMonth ? getDate(date) : ''}</span>
    </td>
  )
})

export default HolidayCalendarCell
